const API_KEY = process.env.API_KEY;
const API_BASE_URL = 'https://nbassessment-l8rxu.ondigitalocean.app/api'; // Temporarily hardcoded
// const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

console.log('API_BASE_URL in assessment.js:', API_BASE_URL);
console.log('process.env.REACT_APP_API_URL:', process.env.REACT_APP_API_URL);

export const getAssessment = async (endpoint) => {
    try {
        console.log('Fetching from:', `${API_BASE_URL}/${endpoint}`);
        const response = await fetch(`${API_BASE_URL}/${endpoint}`, {
            method: 'GET',
            headers: {
                'X-API-KEY': "hsmhMvtKWYmMZGfg7bQHpPgjRrV3qLUH",  // API Key for authentication
            },
        });

        if (!response.ok) {
            throw new Error('Failed to fetch data');
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
      }
};

export const addAssessment = async (endpoint, param) => {
    try {
        const response = await fetch(`${API_BASE_URL}/${endpoint}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-API-KEY': "hsmhMvtKWYmMZGfg7bQHpPgjRrV3qLUH",  // API Key for authentication
            },
            body: JSON.stringify(param)
        });

        if (!response.ok) {
            throw new Error('Failed to fetch data');
        }
        
        return response;
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
    }
};

export const selectLoveInterest = async (endpoint, param) => {
    try {
        const response = await fetch(`${API_BASE_URL}/${endpoint}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-API-KEY': "hsmhMvtKWYmMZGfg7bQHpPgjRrV3qLUH",  // API Key for authentication
            },
            body: JSON.stringify(param)
        });

        if (!response.ok) {
            throw new Error('Failed to fetch data');
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
    }
};